<template>
  <div>
    <generic-container
      :title="$t('top products')"
      icon="cash register"
      :header_buttons="header_buttons"
    >
      <div class="ui basic container" style="margin-bottom: 35px">
        <div class="ui toggle checkbox" style="float: right">
          <input type="checkbox" name="public" v-model="auto_add" />
          <label>{{
            $t("automatically add product if only one is found")
          }}</label>
        </div>
      </div>

      <table
        ref="table"
        class="ui celled selectable striped very compact table"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th>{{ $t("barcode") }}</th>
            <th>{{ $t("internal reference") }}</th>
            <th>{{ $t("product") }}</th>
            <th>{{ $t("sale price") }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </generic-container>
  </div>
</template>

<script>
import { enterprise_setup } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
// import { error_toast } from "../../utils";
import "datatables.net";
import "datatables.net-se";

// @ is an alias to /src
export default {
  name: "PointOfSaleProduct",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      products: [],
      header_buttons: [
        {
          icon: "green refresh",
          tooltip: this.$t("refresh"),
          click: this.refresh,
        },
        // {
        //   icon: "th",
        //   tooltip: this.$t("toggle view"),
        //   click: this.toggle_view,
        // },
      ],
      auto_add: true,
    };
  },
  methods: {
    toggle_view() {
      let vm = this;
      window.jQuery(vm.$refs.table).toggleClass("cards");
    },
    add_to_cart(product) {
      this.$emit("add_to_cart", product);
    },
    refresh() {
      let vm = this;
      let ent_setup = enterprise_setup(vm);
      // local_api(vm, "post", "/point_of_sale/do-get-top-products")
      //   .then((products) => {
      //     vm.products = products.map((p) => {
      //       p.setup.sale_price = Number(p.setup.sale_price) || 0;
      //       p.setup.taxes_percentage = Number(p.setup.taxes_percentage) || 0;
      //       return p;
      //     });

      //     setTimeout(() => {
      //       window.jQuery(vm.$refs.tttt).popup({
      //         lastResort: "bottom right"
      //       });

      let dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/English.json";
      if (vm.$i18n.locale == "es")
        dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/Spanish.json";
      else if (vm.$i18n.locale == "fr")
        dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/French.json";

      if (window.jQuery.fn.DataTable.isDataTable(vm.$refs.table)) {
        window.jQuery(vm.$refs.table).DataTable().destroy();
      }

      let table = window.jQuery(vm.$refs.table).DataTable({
        processing: true,
        serverSide: true,
        language: {
          url: dict,
        },
        ajax: {
          url: window.jQuery.fn.api.settings.api["pos products url"], //"/point_of_sale/do-get-products",
          type: "post",
          beforeSend: function (request) {
            let token = vm.$session.get("token");
            if (token) {
              request.setRequestHeader("x-access-token", token);
            }
          },
          dataSrc: function (json) {
            if (!json.success) vm.$alertify.error(json.error);
            else return json.data;
          },
        },
        columns: [
          {
            data: function (row) {
              // console.log(row);
              return row.barcode;
            },
          },
          {
            data: function (row) {
              return row.internal_reference;
            },
          },
          {
            data: function (row) {
              return row.name;
            },
          },
          {
            data: function (row) {
              return filters.formatCurrency(
                row.sale_price,
                ent_setup.currency_iso,
              );
            },
          },
        ],
        createdRow: function (row, data) {
          window.jQuery(row).click(function () {
            vm.add_to_cart(data);
          });
        },
      });

      // let table = window.jQuery(vm.$refs.table).DataTable({
      //   language: {
      //     url: dict
      //   }
      // });
      table.on("draw.dt", function () {
        let _r = table.rows(); //.select();
        let frst = _r[0];
        if (Array.isArray(frst)) {
          let lngt = frst.length;
          if (lngt == 1 && vm.auto_add) {
            let data = table.rows(frst[0]).data();
            vm.add_to_cart(data[0]);

            window.jQuery(".dataTables_filter input").val("");
            setTimeout(() => {
              window
                .jQuery(vm.$refs.table)
                .find(".dataTables_filter input")
                .focus();
            }, 100);
          }
        }
      });
      //     }, 100);
      //   })
      //   .catch((err) => {
      //     error_toast(err);
      //   });
    },
  },
  mounted() {
    this.refresh();
  },
  watch: {},
};
</script>

<style>
/* table.cards {
  background-color: transparent;
}

.cards tbody img {
  height: 100px;
}
.cards tbody tr {
  float: left;
  margin: 10px;
  border: 1px solid #aaa;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.25);
  background-color: white;
}
.cards tbody td {
  display: block;
  width: 330px;
  overflow: hidden;
  text-align: left;
}

.table {
  background-color: #fff;
}
.table tbody label {
  display: none;
  margin-right: 5px;
  width: 50px;
}
.table .glyphicon {
  font-size: 20px;
}

.cards .glyphicon {
  font-size: 75px;
}

.cards tbody label {
  display: inline;
  position: relative;
  font-size: 85%;
  font-weight: normal;
  top: -5px;
  left: -3px;
  float: left;
  color: #808080;
}
.cards tbody td:nth-child(1) {
  text-align: center;
}

.cards tbody tr {
  float: left;
}
.cards tbody td {
  display: block;
} */
</style>
